var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10625_96174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1951 98.8245C93.7609 99.2572 93.2348 99.5837 92.6212 99.8074L92.002 99.9933C92.002 99.9933 8.51235 133.679 2.02049 127.164C-4.47137 120.648 29.5184 37.2819 29.5184 37.2819L29.7066 36.6634C29.9325 36.0505 30.2611 35.5257 30.6953 35.0931C35.8888 29.9183 54.3153 39.9892 71.85 57.5879C89.3848 75.1867 99.3886 93.6501 94.1951 98.8245Z",
    fill: "url(#paint0_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0006 101.19C84.6067 102.932 75.8089 106.381 65.4203 110.241C59.0665 112.603 52.1171 115.119 45.2164 117.49C39.1861 119.563 33.1919 121.528 27.6686 123.184C23.8737 119.995 20.1025 116.536 16.4078 112.828C12.7131 109.12 9.26818 105.336 6.09277 101.53C7.76907 96.0128 9.75659 90.0254 11.851 84.0029C14.2471 77.1107 16.7883 70.1706 19.1734 63.8256C23.0716 53.451 26.5524 44.666 28.3106 40.2783C39.5128 46.3531 51.4833 55.3369 62.7549 66.6496C74.0266 77.9625 82.9668 89.9657 89.0006 101.19Z",
    fill: "url(#paint1_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1942 98.8228C93.761 99.257 93.2337 99.5818 92.6203 99.8069L92.0019 99.9914C92.0019 99.9914 90.9225 100.427 89.0005 101.189C84.6065 102.931 75.8087 106.38 65.4201 110.24C59.0663 112.602 52.1169 115.118 45.2162 117.489C39.2182 112.966 33.2065 107.74 27.3815 101.893C21.5565 96.047 16.3527 90.0162 11.8506 84.0019C14.2467 77.1098 16.7879 70.1697 19.1729 63.8246C23.0712 53.4501 26.552 44.665 28.3101 40.2774C29.0794 38.3581 29.5189 37.2804 29.5189 37.2804L29.7056 36.6625C29.9332 36.0499 30.2598 35.5238 30.6955 35.0921C35.8892 29.9172 54.314 39.9888 71.85 57.586C89.3837 75.1865 99.388 93.6479 94.1942 98.8228Z",
    fill: "url(#paint2_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1939 98.8236C93.7607 99.2578 93.2334 99.5825 92.62 99.8077L92.0016 99.9921C92.0016 99.9921 90.9221 100.428 89.0001 101.19C84.6062 102.932 75.8083 106.381 65.4198 110.241C56.964 104.672 48.3021 97.6153 40.0193 89.3021C31.7364 80.9889 24.7107 72.3015 19.1729 63.8256C23.0711 53.4511 26.5519 44.666 28.31 40.2784C29.0793 38.3591 29.5188 37.2814 29.5188 37.2814L29.7055 36.6635C29.9331 36.0509 30.2597 35.5248 30.6954 35.0931C35.8892 29.9181 54.3139 39.9897 71.8499 57.587C89.3834 75.1872 99.3877 93.6486 94.1939 98.8236Z",
    fill: "url(#paint3_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1936 98.825C88.9991 104.001 70.5728 93.9299 53.0381 76.3309C35.5033 58.7319 25.4993 40.2696 30.6938 35.0936C35.8883 29.9176 54.3146 39.9887 71.8493 57.5877C89.3841 75.1867 99.3881 93.6493 94.1936 98.825Z",
    fill: "url(#paint4_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9567 94.0808C87.1192 97.9045 71.5772 88.5278 56.2431 73.1377C40.9089 57.7476 31.589 42.1718 35.4265 38.3481C39.264 34.5244 54.8059 43.901 70.1401 59.2911C85.4742 74.6813 94.7944 90.2571 90.9567 94.0808Z",
    fill: "url(#paint5_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1951 98.8245C99.3886 93.6498 89.385 75.1869 71.8501 57.5881C61.5681 47.2688 50.981 39.5399 42.9336 35.9531C43.2478 36.5314 43.5984 37.1046 43.9902 37.6698C44.627 38.5884 45.3724 39.4257 46.2116 40.1806L50.6643 44.6642C50.151 44.8971 49.6794 45.0813 49.2829 45.2211C48.5729 45.4713 48.1572 46.2057 48.3058 46.9436L49.8815 54.7701C50.0208 55.4621 50.5062 55.9876 51.1128 56.2173L93.8608 99.1211C93.9775 99.0288 94.0892 98.9301 94.1951 98.8245Z",
    fill: "url(#paint6_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7707 74.5075L70.1433 79.7347L90.5121 100.178C92.069 100.134 93.3198 99.6964 94.1943 98.825C98.7335 94.3021 91.6666 79.6333 78.1107 64.2607C73.8864 66.0249 69.8595 68.3342 66.1407 71.1735C65.0901 71.9751 64.9227 73.4938 65.7707 74.5075Z",
    fill: "url(#paint7_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1433 79.7343L65.7707 74.5071C64.9227 73.4934 65.0901 71.975 66.1404 71.1728C79.6916 60.8269 97.3182 57.4666 113.78 62.2013C117.923 63.3927 121.891 65.0635 125.604 67.1785C126.753 67.8328 127.121 69.3163 126.415 70.4342L122.778 76.197C122.118 77.2418 120.758 77.5831 119.68 76.9793C116.829 75.3825 113.79 74.1153 110.616 73.2028C97.7424 69.5001 83.9636 72.0837 73.3172 80.0975C72.3304 80.8401 70.9357 80.6815 70.1433 79.7343Z",
    fill: "url(#paint8_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.358 25.4672L28.3877 21.382C26.5882 19.5302 26.0463 16.5496 27.0972 14.2832C28.3172 11.6517 31.2451 10.8804 33.6033 12.5693C35.6345 14.024 36.6314 16.8846 35.9776 19.3827L34.5355 24.8937C34.2807 25.8675 33.0597 26.1892 32.358 25.4672Z",
    fill: "url(#paint9_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3361 29.9038L19.6986 29.0846C17.1434 28.7134 14.8971 26.6804 14.349 24.2432C13.7125 21.4131 15.5637 19.0172 18.4625 18.9191C20.9593 18.8345 23.4932 20.4948 24.4974 22.8738L26.7128 28.1221C27.1045 29.0494 26.3323 30.0486 25.3361 29.9038Z",
    fill: "url(#paint10_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.817 95.4353L106.49 94.9218C109.062 94.6892 111.719 96.1441 112.818 98.3874C114.095 100.992 112.851 103.752 110.055 104.522C107.646 105.184 104.796 104.158 103.266 102.078L99.8914 97.4883C99.2953 96.6772 99.8139 95.5259 100.817 95.4353Z",
    fill: "url(#paint11_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.789 87.1858L105.974 83.321C107.871 81.5691 110.865 81.1036 113.104 82.2117C115.703 83.4984 116.4 86.4449 114.651 88.7595C113.145 90.753 110.26 91.6766 107.78 90.9596L102.307 89.3774C101.34 89.0978 101.05 87.8688 101.789 87.1858Z",
    fill: "url(#paint12_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3943 56.2505C51.2842 56.6084 50.1112 55.9132 49.881 54.7698L48.3054 46.9432C48.1568 46.2051 48.5724 45.4709 49.2824 45.2207C50.1122 44.9283 51.2652 44.4472 52.4571 43.7143C48.8573 42.5259 45.9281 40.4654 43.99 37.6695C40.3362 32.3981 40.0499 26.4564 43.2235 21.7754C46.364 17.1433 52.1669 14.8835 57.6647 16.1527C63.6749 17.5401 67.8966 22.7989 68.9578 30.2204C69.002 30.5293 69.0411 30.8368 69.075 31.143C70.5495 30.2791 71.7409 29.2134 72.4871 28.0205C74.3759 25.0015 74.5551 20.4959 72.9444 16.5422C71.9219 14.0329 70.3434 12.1139 68.5632 11.1486C67.7691 10.7182 67.346 9.82495 67.5588 8.94727L69.3639 1.50394C69.6404 0.363991 70.8547 -0.292072 71.9502 0.127567C77.0022 2.06238 81.1589 6.36543 83.5455 12.2223C86.5447 19.5831 86.0262 27.9628 82.192 34.0917C79.1584 38.9407 73.5635 42.5576 67.0943 44.0865C65.6411 47.1249 63.4663 49.7941 60.6139 51.9809C57.568 54.3155 54.4125 55.6 52.3943 56.2505ZM54.6381 27.2565C53.8894 27.2553 53.0855 27.628 52.6985 28.1992C52.1203 29.0521 52.8888 30.4131 53.3982 31.1482C54.097 32.1564 55.7238 32.9086 57.7731 33.2454C57.7435 32.7892 57.6943 32.3211 57.6255 31.8407C57.2598 29.2837 56.3119 27.5888 55.0896 27.3067C54.9443 27.2731 54.7924 27.2568 54.6381 27.2565Z",
    fill: "url(#paint13_radial_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2803 39.378L69.0747 31.1426C69.0747 31.1426 69.5988 39.0946 67.0938 44.0864C70.9089 43.1849 74.4194 41.5565 77.2803 39.378Z",
    fill: "url(#paint14_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3983 31.1488C53.0251 30.6102 52.5151 29.7365 52.495 28.972L41.0322 28.9512C41.05 31.8528 42.0402 34.8567 43.99 37.67C45.9281 40.4662 48.857 42.5267 52.4571 43.7148C52.4571 43.7148 58.3321 41.9326 57.7734 33.2459C55.7239 32.9091 54.097 32.1569 53.3983 31.1488Z",
    fill: "url(#paint15_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7058 57.2186C75.0449 58.9526 72.7743 61.2367 71.055 63.9087C70.6683 64.5095 69.7761 64.508 69.3915 63.9057C67.6819 61.2275 65.42 58.935 62.7652 57.1912C62.1759 56.8042 62.1776 55.924 62.7682 55.5392C65.4291 53.8052 67.6994 51.521 69.4189 48.8491C69.8054 48.2483 70.6979 48.2498 71.0824 48.8521C72.7921 51.5303 75.0542 53.8228 77.7088 55.5666C78.2981 55.9536 78.2963 56.8338 77.7058 57.2186Z",
    fill: "url(#paint16_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.36 53.7195C123.699 55.4536 121.429 57.7377 119.709 60.4097C119.323 61.0105 118.43 61.009 118.046 60.4067C116.336 57.7284 114.074 55.436 111.419 53.6922C110.83 53.3052 110.832 52.425 111.422 52.0402C114.083 50.3062 116.354 48.022 118.073 45.3501C118.46 44.7492 119.352 44.7507 119.737 45.3531C121.446 48.0313 123.708 50.3238 126.363 52.0676C126.952 52.4543 126.951 53.3345 126.36 53.7195Z",
    fill: "url(#paint17_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.575 14.8592C100.914 16.5932 98.6434 18.8774 96.9242 21.5493C96.5374 22.1502 95.6452 22.1487 95.2607 21.5463C93.551 18.8681 91.2892 16.5756 88.6343 14.8318C88.045 14.4448 88.0468 13.5646 88.6373 13.1799C91.2982 11.4458 93.5686 9.16167 95.288 6.48973C95.6746 5.88889 96.567 5.89039 96.9515 6.49275C98.6612 9.17096 100.923 11.4634 103.578 13.2072C104.167 13.5942 104.165 14.4744 103.575 14.8592Z",
    fill: "url(#paint18_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.109 41.6564C99.1691 42.9206 97.5141 44.5856 96.2608 46.5332C95.9789 46.9712 95.3284 46.9699 95.0483 46.531C93.8021 44.5786 92.1532 42.9076 90.2179 41.6364C89.7885 41.3543 89.7895 40.7127 90.2202 40.4322C92.16 39.168 93.8149 37.503 95.0683 35.5554C95.3502 35.1174 96.0007 35.1184 96.2808 35.5576C97.5272 37.51 99.1761 39.181 101.111 40.4522C101.541 40.7343 101.54 41.3758 101.109 41.6564Z",
    fill: "url(#paint19_linear_10625_96174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.009 26.5998C107.07 27.864 105.415 29.529 104.161 31.4766C103.879 31.9146 103.229 31.9133 102.949 31.4743C101.703 29.522 100.054 27.8509 98.1183 26.5797C97.6889 26.2976 97.6899 25.6561 98.1205 25.3755C100.06 24.1113 101.715 22.4463 102.969 20.4987C103.251 20.0608 103.901 20.0618 104.181 20.501C105.428 22.4533 107.077 24.1244 109.012 25.3956C109.441 25.6777 109.44 26.3192 109.009 26.5998Z",
    fill: "url(#paint20_linear_10625_96174)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10625_96174",
    x1: 17.6913,
    y1: 62.6153,
    x2: 54.843,
    y2: 116.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#FFDE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#FFCA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#FFAA87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF90A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10625_96174",
    x1: 46.6308,
    y1: 104.529,
    x2: 39.4577,
    y2: 129.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA5C2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3857,
    stopColor: "#FCA0BA",
    stopOpacity: 0.386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9737,
    stopColor: "#FF91A5",
    stopOpacity: 0.974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF90A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10625_96174",
    x1: 53.8368,
    y1: 89.4656,
    x2: 44.9544,
    y2: 121.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA5C2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3857,
    stopColor: "#FCA0BA",
    stopOpacity: 0.386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9737,
    stopColor: "#FF91A5",
    stopOpacity: 0.974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF90A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10625_96174",
    x1: 59.7348,
    y1: 72.1599,
    x2: 48.6389,
    y2: 108.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA5C2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3857,
    stopColor: "#FCA0BA",
    stopOpacity: 0.386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9737,
    stopColor: "#FF91A5",
    stopOpacity: 0.974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF90A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10625_96174",
    x1: 66.0472,
    y1: 58.8401,
    x2: 54.2926,
    y2: 85.2731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#FFDE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#FFCA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#FFAA87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF90A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10625_96174",
    x1: 54.9613,
    y1: 78.8144,
    x2: 71.5472,
    y2: 53.4091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD00D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB722B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10625_96174",
    x1: 70.3268,
    y1: 67.6741,
    x2: 59.9607,
    y2: 35.8551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD00D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB722B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10625_96174",
    x1: 82.647,
    y1: 85.2256,
    x2: 74.2796,
    y2: 71.4719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A34A9E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10625_96174",
    x1: 95.8197,
    y1: 80.9252,
    x2: 96.2012,
    y2: 59.9564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A34A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10625_96174",
    x1: 30.3333,
    y1: 17.8707,
    x2: 34.9428,
    y2: 19.8765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666AD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10625_96174",
    x1: 19.2089,
    y1: 25.0691,
    x2: 24.0832,
    y2: 23.8514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A34A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10625_96174",
    x1: 107.541,
    y1: 98.7516,
    x2: 95.4854,
    y2: 106.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4497,
    stopColor: "#FE4773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6292,
    stopColor: "#FC406D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7605,
    stopColor: "#F73464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    stopColor: "#F12257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9606,
    stopColor: "#E80C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4003D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10625_96174",
    x1: 109.712,
    y1: 83.8138,
    x2: 104.084,
    y2: 99.9138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4F8B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8EAC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_10625_96174",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.7828 9.36187) rotate(0.114591) scale(50.3864)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4497,
    stopColor: "#FE4773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6292,
    stopColor: "#FC406D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7605,
    stopColor: "#F73464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    stopColor: "#F12257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9606,
    stopColor: "#E80C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4003D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10625_96174",
    x1: 78.6656,
    y1: 45.2857,
    x2: 60.5032,
    y2: 32.1484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    stopColor: "#CD0E2D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#972E07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10625_96174",
    x1: 51.1015,
    y1: 35.9047,
    x2: 56.18,
    y2: 40.6211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    stopColor: "#CD0E2D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#972E07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10625_96174",
    x1: 67.6476,
    y1: 52.9385,
    x2: 76.02,
    y2: 64.1483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666AD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10625_96174",
    x1: 116.302,
    y1: 49.448,
    x2: 124.675,
    y2: 60.6577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666AD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10625_96174",
    x1: 93.5245,
    y1: 10.5838,
    x2: 101.897,
    y2: 21.7936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A34A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10625_96174",
    x1: 93.7772,
    y1: 38.5445,
    x2: 99.8802,
    y2: 46.7161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4F8B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8EAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10625_96174",
    x1: 101.68,
    y1: 23.489,
    x2: 107.783,
    y2: 31.6606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#FFDE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#FFCA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#FFAA87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF90A4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10625_96174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/Confetti.ebd9a77a5e1663b4ad6b5823922c9bfe.svg";
export { ForwardRef as ReactComponent };